<script lang="ts" setup>
import { DocumentGradedStateLabels } from "~/types/enums/DocumentGradedState.enum";

const documentId = inject("documentId") as any;
const documentChecklistStore = useDocumentChecklistStore(documentId);
const { useChecklist } = storeToRefs(documentChecklistStore);

const documentStore = useSubmittedDocumentStore(documentId);
const { submittedDocument } = storeToRefs(documentStore);

const showSubTitle = computed(() => {
  return (
    useChecklist.value?.lessonName.includes("OSS") ||
    submittedDocument.value?.enteredName != undefined ||
    submittedDocument.value?.studentName != null
  );
});

const unit = computed(() => {
  return useChecklist.value?.unit ? `Unit ${useChecklist.value?.unit} ` : "";
});

const showTotals = computed(() => {
  return (
    submittedDocument.value?.documentSubmissionType ==
    DocumentSubmissionType.finalDraft
  );
});

const showGradedState = computed(() => {
  var submissionType =
    submittedDocument.value?.documentSubmissionType ??
    DocumentSubmissionType.finalDraft;

  if (
    [
      DocumentSubmissionType.keyWordOutline,
      DocumentSubmissionType.roughDraft,
    ].includes(submissionType) == true
  ) {
    return true;
  }

  if (submittedDocument?.value?.allowFinalDraftGradedState != true) {
    return false;
  }

  return (
    submittedDocument.value != undefined &&
    submittedDocument.value?.state == DocumentState.graded &&
    submittedDocument.value?.documentGradedState != undefined
  );
});
</script>

<template>
  <div v-if="useChecklist" class="mb-4 w-full">
    <h2 class="text-h5 font-bold">
      {{ `${unit}Composition Checklist` }}
      {{ useChecklist.isAdvancedChecklist ? "Advanced Aditions" : "" }}
    </h2>
    <h2 class="text-h6" v-if="useChecklist.lessonName">
      {{
        `${useChecklist.lessonName}: ${
          useChecklist.subject ?? useChecklist.title
        }`
      }}
    </h2>
    <h3 v-if="showSubTitle && submittedDocument" class="text-body-1">
      Name: {{ submittedDocument.enteredName ?? submittedDocument.studentName }}
    </h3>

    <div class="rounded border overflow-hidden w-full mt-2">
      <table class="w-full border-none">
        <thead>
          <tr class="border-b">
            <th class="text-center p-1 border-r w-[40px]">X</th>
            <th class="text-left p-2 border-r">Task</th>
            <th class="text-center p-2">Points</th>
          </tr>
        </thead>
        <DocumentChecklistCriteria
          v-for="(criteria, index) in useChecklist.criteriaInstances"
          :key="index"
          :criteria="criteria"
          :paragraph-position-data="useChecklist.paragraphPositionsData"
        />
        <DocumentChecklistSection
          v-for="section in useChecklist.sections ?? []"
          :key="section.id"
          :section="section"
          :paragraph-position-data="useChecklist.paragraphPositionsData"
        />
        <DocumentChecklistCriteria
          v-for="(criteria, index) in useChecklist.customCriteriaInstances"
          :key="index"
          :criteria="criteria"
        />
        <tr v-if="showGradedState && submittedDocument?.documentGradedState">
          <td
            class="border text-center p-2 font-bold"
            colspan="3"
            :class="{
              ' text-success-default bg-success-default bg-opacity-20':
                submittedDocument.documentGradedState ==
                DocumentGradedState.accepted,
              'text-warning-default bg-warning-default bg-opacity-20':
                submittedDocument.documentGradedState ==
                DocumentGradedState.incomplete,
            }"
          >
            {{
              DocumentGradedStateLabels[submittedDocument.documentGradedState]
            }}
          </td>
        </tr>
        <tr v-if="showGradedState != true">
          <td class="border" />
          <td class="text-right px-2 py-1 font-bold border">Total</td>
          <td
            v-if="submittedDocument"
            class="font-bold px-2 py-1 whitespace-nowrap text-center"
          >
            {{ submittedDocument.earnedPoints }}/{{
              submittedDocument.maxPoints
            }}
          </td>
        </tr>
      </table>
    </div>
    <DocumentsItemNewSubmissionButton
      v-if="
        submittedDocument &&
        submittedDocument.classroomId &&
        submittedDocument.studentId
      "
      :submittedDocument="submittedDocument"
      :classroomId="submittedDocument.classroomId"
      :studentId="submittedDocument.studentId"
      class="mt-4 w-full"
    />
  </div>
</template>

<style scoped></style>
